import { SvgIcon } from '@material-ui/core'

export default function MessagesIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M12.3609 4C6.58066 4 2.64251 9.85685 4.82339 15.2099L5.75573 17.4984C5.83916 17.7032 5.77817 17.9384 5.60576 18.0769L3.63427 19.6602C3.46884 19.793 3.40528 20.0158 3.4757 20.2159C3.54611 20.4161 3.73518 20.55 3.94735 20.55H11.7676C16.5904 20.55 20.5 16.6404 20.5 11.8176C20.5 7.50008 16.9999 4 12.6823 4H12.3609Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
